module.exports = __webpack_public_path__ + "static/media/jm.869df1c4.svg";